import React, { useEffect, useRef, useState } from "react";
import { fetchCommunitylist } from "../services/Communitylist";
import { API_BASE } from "../api/apiConfig";

const Communitylist = () => {
  const [community, setcommunity] = useState([]);
  const [activeCountry, setActiveCountry] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const sliderRef = useRef(null);

  useEffect(() => {
    const loadData = async () => {
      const res = await fetchCommunitylist();
      if (res?.status && Array.isArray(res.data)) {
        setcommunity(res.data);
      }
    };
    loadData();
  }, []);


   /* ================= HELPERS ================= */
  const parseCategories = (category) => {
    if (!category) return [];
    try {
      const parsed = JSON.parse(category);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  /* ================= FILTER DATA ================= */

  const countries = [
    "All",
    ...new Set(community.map((m) => m.country).filter(Boolean)),
  ];

  const cities = [
    "All",
    ...new Set(
      community
        .filter(
          (m) => activeCountry === "All" || m.country === activeCountry
        )
        .map((m) => m.city)
        .filter(Boolean)
    ),
  ];

  const filteredcommunity = community.filter((m) => {
    if (activeCountry !== "All" && m.country !== activeCountry) return false;
    if (activeCity !== "All" && m.city !== activeCity) return false;
    return true;
  });

  /* ================= SLIDER SCROLL ================= */

  const scrollSlider = (dir) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollBy({
      left: dir === "next" ? 350 : -350,
      behavior: "smooth",
    });
  };

  return (
    <div className="relative -mx-4 px-4 sm:-mx-5 sm:px-5 md:mx-0 md:px-0">
    <button onClick={() => scrollSlider("prev")}
        className="customPrevBtn absolute -left-1 md:-left-2 top-1/2 z-10 flex h-9 w-9 md:h-10 md:w-10 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:left-2"
        aria-label="Previous city"
    >
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-chevron-left h-4 w-4 md:h-5 md:w-5"
        >
        <path d="m15 18-6-6 6-6" />
        </svg>
    </button>
    <div
        className="flex snap-x snap-mandatory gap-3 md:gap-4 overflow-x-auto pb-6 scrollbar-hide"
        style={{ scrollbarWidth: "none" }}
    >
  
   <div
      ref={sliderRef}
      className="flex w-full gap-4 overflow-x-auto scroll-smooth pb-6 scrollbar-hide"
    >

  {filteredcommunity.map((item, i) => (
    <div
    className="text-card-foreground group min-w-[300px] max-w-[85vw] sm:min-w-[320px] md:min-w-[340px] md:max-w-[380px] flex-shrink-0 snap-start overflow-hidden rounded-2xl border-2 border-slate-200 bg-white shadow-lg transition-all duration-700 hover:border-primary/30 hover:shadow-2xl hover:-translate-y-2"
    style={{ transitionDelay: "400ms" }}
    >
    <a className="block h-full" href={`/CommunityDtl/${item.id}`}>
        <div className="relative h-48 md:h-52 w-full overflow-hidden">
        <img
            alt={item.city}
            loading="lazy"
            decoding="async"
            data-nimg="fill"
            className="object-cover transition-transform duration-700 group-hover:scale-110"
            style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            inset: 0
            }}
            src={
              item.image
                ? `${API_BASE}${item.image}`
                : `${API_BASE}default.jpg`
            }
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent transition-opacity duration-300 group-hover:opacity-80" />
        <div className="inline-flex items-center rounded-full border focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 absolute right-4 top-4 border-none bg-gradient-to-r from-primary to-primary/80 text-white text-sm font-semibold px-3 py-1.5 shadow-lg hover:shadow-xl transition-all duration-300 group-hover:scale-110">
            {item.monthly_meetups}x Monthly
        </div>
        <div className="absolute bottom-4 left-4 right-4 transition-transform duration-300 group-hover:translate-y(-2px)">
            <div className="flex items-center gap-2 mb-2">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-map-pin h-5 w-5 md:h-6 md:w-6 text-primary animate-bounce"
                style={{ animationDelay: "0.8s" }}
            >
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                <circle cx={12} cy={10} r={3} />
            </svg>
            <span className="text-2xl md:text-3xl font-bold text-white drop-shadow-lg">
                {item.city}
            </span>
            </div>
            <div className="flex items-center gap-2">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-users h-4 w-4 text-white/80"
            >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx={9} cy={7} r={4} />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span className="text-white/90 font-medium">
                {item.community_members} active travelers
            </span>
            </div>
        </div>
        </div>
        <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
            <div className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-gradient-to-r from-primary/10 to-primary/5">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-users h-4 w-4 text-slate-600"
            >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx={9} cy={7} r={4} />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <span className="text-sm font-semibold text-slate-700">
                {item.active_member} members
            </span>
            </div>
            <div className="flex items-center gap-1">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400 transition-transform duration-300 hover:scale-125"
                style={{ transitionDelay: "0ms" }}
            >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
            </svg>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400 transition-transform duration-300 hover:scale-125"
                style={{ transitionDelay: "50ms" }}
            >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
            </svg>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400 transition-transform duration-300 hover:scale-125"
                style={{ transitionDelay: "100ms" }}
            >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
            </svg>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400 transition-transform duration-300 hover:scale-125"
                style={{ transitionDelay: "150ms" }}
            >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
            </svg>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-star h-4 w-4 fill-amber-400 text-amber-400 transition-transform duration-300 hover:scale-125"
                style={{ transitionDelay: "200ms" }}
            >
                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z" />
            </svg>
            </div>
        </div>
        <div className="rounded-xl border-2 border-slate-100 bg-gradient-to-br from-primary/10 to-primary/5 p-4 transition-all duration-300 group-hover:border-primary/20 group-hover:shadow-md">
            <p className="text-sm md:text-base italic text-slate-700 leading-relaxed mb-3 transition-all duration-300 group-hover:text-slate-800">
            "{/* */}Our weekend trips to nearby temples and beaches have become
            legendary among South Indian travel groups.{/* */}"
            </p>
            <div className="flex items-center gap-2">
            <div className="h-8 w-8 rounded-full bg-gradient-to-r from-primary to-primary/80 flex items-center justify-center text-white font-bold text-sm">
                A
            </div>
            <p className="text-sm font-semibold text-slate-800">Arun M.</p>
            </div>
        </div>
        </div>
    </a>
    </div>
  ))}

    </div>
    
    </div>
    <button onClick={() => scrollSlider("next")}
        className="customNextBtn absolute -right-1 md:-right-2 top-1/2 z-10 flex h-9 w-9 md:h-10 md:w-10 -translate-y-1/2 items-center justify-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-md transition-all duration-300 hover:bg-primary/10 hover:text-primary hover:scale-110 md:right-2"
        aria-label="Next city"
    >
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="lucide lucide-chevron-right h-4 w-4 md:h-5 md:w-5"
        >
        <path d="m9 18 6-6-6-6" />
        </svg>
    </button>
    </div>
  );
};

export default Communitylist;
